/* global self */
'use strict';

module.exports = function (domain, opts, callback) {
  domain = encodeURIComponent(domain);
  var url = "https://ipfs.io/api/v0/dns?arg=".concat(domain);

  for (var prop in opts) {
    url += "&".concat(prop, "=").concat(opts[prop]);
  }

  self.fetch(url, {
    mode: 'cors'
  }).then(function (response) {
    return response.json();
  }).then(function (response) {
    if (response.Path) {
      return callback(null, response.Path);
    } else {
      return callback(new Error(response.Message));
    }
  }).catch(function (error) {
    callback(error);
  });
};